module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.lesson && _vm.modules) ? _c('div', {
    staticClass: "container p-3",
    class: {
      'small': _vm.fontSize === 's',
        'medium': _vm.fontSize === 'm',
        'large': _vm.fontSize === 'l'
    },
    attrs: {
      "id": "interactive-player",
      "lang": _vm.lesson.language
    },
    on: {
      "mousemove": function($event) {
        _vm.activeHandler()
      }
    }
  }, [(false) ? _c('div', {
    staticClass: "row text-left",
    attrs: {
      "id": "title"
    }
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v(_vm._s(_vm.lesson.name))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 text-right"
  }, [_vm._t("actions")], 2), _vm._v(" "), _c('p', {
    staticClass: "col-sm-12"
  }, [_vm._v(_vm._s(_vm.lesson.localName))])]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "switcher",
    staticClass: "text-right pb-1"
  }, [(_vm.moduleEnable.indexOf('video') > -1 && _vm.modules.video) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'video'
    },
    on: {
      "click": function($event) {
        _vm.goPage('video')
      }
    }
  }, [(_vm.page == 'video') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_video_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_video_off.png")
    }
  }), _vm._v(" 影片\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('article') > -1 && !_vm.modules.video && _vm.modules.sentences) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'article'
    },
    on: {
      "click": function($event) {
        _vm.goPage('article')
      }
    }
  }, [(_vm.page == 'article') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_book_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_book_off.png")
    }
  }), _vm._v(" 閱讀\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('ebook') > -1 && _vm.modules.ebook) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'ebook'
    },
    on: {
      "click": function($event) {
        _vm.goPage('ebook')
      }
    }
  }, [(_vm.page == 'ebook') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_lesson_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_lesson_off.png")
    }
  }), _vm._v(" 課程\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('vocabulary') > -1 && _vm.modules.vocabulary) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'vocabulary'
    },
    on: {
      "click": function($event) {
        _vm.goPage('vocabulary')
      }
    }
  }, [(_vm.page == 'vocabulary') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_lesson_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_lesson_off.png")
    }
  }), _vm._v(" 圖解單字\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('text') > -1 && _vm.modules.sentences) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'text'
    },
    on: {
      "click": function($event) {
        _vm.goPage('text')
      }
    }
  }, [(_vm.page == 'text') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_text_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_text_off.png")
    }
  }), _vm._v(" 文字\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('reading') > -1 && _vm.modules.sentences) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'reading'
    },
    on: {
      "click": function($event) {
        _vm.goPage('reading')
      }
    }
  }, [(_vm.page == 'reading') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_read_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_read_off.png")
    }
  }), _vm._v(" 跟讀\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('detail') > -1 && _vm.modules.explAudio) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'detail'
    },
    on: {
      "click": function($event) {
        _vm.goPage('detail')
      }
    }
  }, [(_vm.page == 'detail') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_magic_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_magic_off.png")
    }
  }), _vm._v(" 講解\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('detail') > -1 && _vm.modules.explVideo) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'detailV'
    },
    on: {
      "click": function($event) {
        _vm.goPage('detailV')
      }
    }
  }, [(_vm.page == 'detailV') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_magic_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_magic_off.png")
    }
  }), _vm._v(" 講解影片\n    ")]) : _vm._e(), _vm._v(" "), (_vm.moduleEnable.indexOf('practice') > -1 && _vm.questions && _vm.questions.length > 0) ? _c('button', {
    class: {
      'btn btn-tab': true, 'active': _vm.page === 'practice'
    },
    on: {
      "click": function($event) {
        _vm.goPage('practice')
      }
    }
  }, [(_vm.page == 'practice') ? _c('img', {
    attrs: {
      "src": require("../assets/images/icon_quiz_on.png")
    }
  }) : _c('img', {
    attrs: {
      "src": require("../assets/images/icon_quiz_off.png")
    }
  }), _vm._v(" 測驗\n    ")]) : _vm._e()]), _vm._v(" "), (_vm.page === 'video') ? _c('div', [_c('player', {
    ref: "Player",
    attrs: {
      "language": _vm.lesson.language,
      "url": (_vm.modules.video !== null) ? _vm.modules.video : _vm.modules.audio,
      "subtitles": _vm.modules.sentences
    },
    on: {
      "video": _vm.updateVideoState
    }
  }), _vm._v(" "), _c('sentences', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.video.cc),
      expression: "video.cc"
    }],
    attrs: {
      "texts": _vm.modules.sentences,
      "currentTime": _vm.video.currentTime,
      "multiple": false,
      "lang": _vm.lang,
      "highlight": _vm.modules.vocabularies
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'article') ? _c('div', [_c('mini-player', {
    ref: "MiniPlayer",
    attrs: {
      "url": _vm.modules.audio,
      "subtitles": _vm.modules.sentences
    },
    on: {
      "video": _vm.updateVideoState
    }
  }), _vm._v(" "), _c('articles', {
    attrs: {
      "texts": _vm.modules.sentences,
      "currentTime": _vm.video.currentTime,
      "highlight": _vm.modules.vocabularies
    },
    on: {
      "selectSentId": _vm.playSingle
    }
  }), _vm._v(" "), _c('font-size-switcher', {
    staticClass: "mt-2",
    attrs: {
      "size": _vm.fontSize
    },
    on: {
      "size": function (size) {
        this$1.fontSize = size
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'ebook') ? _c('ebook', {
    attrs: {
      "data": _vm.modules.ebook
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page === 'vocabulary') ? _c('div', [_c('picture-vocabulary', {
    attrs: {
      "data": _vm.modules.vocabulary
    }
  }), _vm._v(" "), _c('font-size-switcher', {
    staticClass: "mt-2",
    attrs: {
      "size": _vm.fontSize
    },
    on: {
      "size": function (size) {
        this$1.fontSize = size
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'text') ? _c('texts', {
    ref: "texts",
    attrs: {
      "url": (_vm.modules.video !== null) ? _vm.modules.video : _vm.modules.audio,
      "data": _vm.modules.sentences,
      "dictionary": [],
      "vocabularies": _vm.modules.vocabularies,
      "phrases": _vm.modules.highlights,
      "config": {
        lessonId: _vm.lesson.id,
        slowAudioUrl: _vm.modules.slowAudio
      }
    }
  }, [_c('font-size-switcher', {
    attrs: {
      "slot": "left",
      "size": _vm.fontSize
    },
    on: {
      "size": function (size) {
        this$1.fontSize = size
      }
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'reading') ? _c('recorder', {
    attrs: {
      "mediaSrc": (_vm.modules.video !== null) ? _vm.modules.video : _vm.modules.audio,
      "data": _vm.modules.sentences
    }
  }, [_c('font-size-switcher', {
    attrs: {
      "slot": "left",
      "size": _vm.fontSize
    },
    on: {
      "size": function (size) {
        this$1.fontSize = size
      }
    },
    slot: "left"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'detail') ? _c('div', [_c('mini-player', {
    ref: "detailPlayer",
    staticStyle: {
      "border": "1px solid #ccc",
      "border-bottom": "0"
    },
    attrs: {
      "url": _vm.modules.explAudio
    },
    on: {
      "video": _vm.updateVideoState
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('sentences', {
    attrs: {
      "texts": _vm.modules.sentences,
      "highlight": _vm.modules.vocabularies,
      "size": _vm.fontSize,
      "lang": ['en_us']
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('font-size-switcher', {
    attrs: {
      "size": _vm.fontSize
    },
    on: {
      "size": function (size) {
        this$1.fontSize = size
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'detailV') ? _c('div', [_c('player', {
    attrs: {
      "url": _vm.modules.explVideo
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.page === 'practice') ? _c('practice', {
    attrs: {
      "quests": _vm.questions
    },
    on: {
      "score": _vm.handlerPracticeScore
    }
  }, [_c('font-size-switcher', {
    attrs: {
      "slot": "left",
      "size": _vm.fontSize
    },
    on: {
      "size": function (size) {
        this$1.fontSize = size
      }
    },
    slot: "left"
  })], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e1b60e4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live-player/components/LivePlayer.vue
// module id = 725
// module chunks = 1